import { apiFetchAccounts } from './apiAccounts';
import { normalizeRef } from '@/lib/utils/normalizeRef';

export type FavoriteItem = {
  reference_no: string;
  application_uid?: string | null;
  source_council?: string | null;
  source_system?: string | null;
  note?: string | null;
  created_at?: string;
  description?: string | null;
  address?: string | null;
  status?: string | null;
  received_date?: string | null;
  validated_date?: string | null;
};

type FavoriteRequestOptions = {
  note?: string;
  council?: string;
};

const appendCouncilQuery = (path: string, council?: string) =>
  council ? `${path}${path.includes('?') ? '&' : '?'}council=${encodeURIComponent(council)}` : path;

export async function listFavorites(council?: string): Promise<FavoriteItem[]> {
  return apiFetchAccounts(appendCouncilQuery('/favorites', council), { method: 'GET' });
}

export async function addFavorite(
  referenceNo: string,
  noteOrOptions?: string | FavoriteRequestOptions,
  council?: string
) {
  const normalized = normalizeRef(referenceNo) ?? referenceNo;
  if (!normalized) return;
  const options =
    typeof noteOrOptions === 'string'
      ? { note: noteOrOptions, council }
      : { ...(noteOrOptions || {}), council: noteOrOptions?.council || council };
  return apiFetchAccounts(appendCouncilQuery(`/favorites/${encodeURIComponent(normalized)}`, options.council), {
    method: 'PUT',
    body: JSON.stringify(options.note ? { note: options.note } : {}),
  });
}

export async function removeFavorite(referenceNo: string, council?: string) {
  const normalized = normalizeRef(referenceNo) ?? referenceNo;
  if (!normalized) return;
  return apiFetchAccounts(appendCouncilQuery(`/favorites/${encodeURIComponent(normalized)}`, council), {
    method: 'DELETE',
  });
}




